import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase'

import Home from '@/views/Home.vue';
import About from '@/views/About.vue'
import Login from '@/components/Login.vue'
import Logout from '@/components/Logout.vue'
import Movie from '@/views/Movie'
import Person from '@/views/Person'
import Settings from '@/views/Settings'

Vue.use(VueRouter);

const routes = [
	{
		path: '*',
		redirect: '/'
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '/logout',
		name: 'Logout',
		component: Logout
	},
	{
		path: '/movie/:movie_id?',
		name: 'Movie',
		component: Movie
	},
	{
		path: '/person/:person_id?',
		name: 'Person',
		component: Person
	},
	{
		path: '/settings',
		name: 'Settings',
		component: Settings,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes,
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
	const currentUser = firebase.auth().currentUser

	if (requiresAuth && !currentUser) {
		next('/login')
	} else if (requiresAuth && currentUser) {
		next()
	} else {
		next()
	}
})

export default router;
